import { IProfilePlan } from '@app/profile/main/details';
import { ProfilePlanActions, ProfilePlanActionTypes } from '@app/profile/profile-remaining-count/profile-plan.actions';

export const profilePlanSelector = state => state.profilePlan as IProfilePlan;

export function profilePlanReducer(
    state: IProfilePlan,
    action: ProfilePlanActions
): IProfilePlan {
    switch (action.type) {
        case ProfilePlanActionTypes.UPDATE:
            return {
                ...state,
                remainingCount: action.payload.profilePlan.remainingCount,
                packageEndDate: action.payload.profilePlan.packageEndDate,
                packageData: action.payload.profilePlan.packageData
            };
        case ProfilePlanActionTypes.CLEAR:
            return null;
        case ProfilePlanActionTypes.EMERGENCY:
            return state;
        default:
            return state;
    }
}
